<template>
  <div class="active-questions">
    <div @click="handle2Detail({type: 2})" class="que-item">
      <div class="title">
        <img src="@/assets/image/quick.png" alt="" />
        <span>快速答题</span>
        <div v-if="simpleItem && simpleItem.status" class="tip" :class="{active: simpleItem.status === 1}">
          {{ simpleItem.status === 1 ? '进行中' : '已结束' }}
        </div>
      </div>
    </div>

    <van-swipe-cell v-for="(item, index) in list" :key="index" :disabled="item.status === 1">
      <div v-if="item.type != 2" @click="handle2Detail(item)" class="que-item">
        <div class="title">
          {{ item.name }}
        </div>
        <div v-if="item.status" class="tip" :class="{active: item.status === 1}">
          {{ item.status === 1 ? '进行中' : '已结束' }}
        </div>
        <div v-else class="tip">
          未发布
        </div>
      </div>
      <template #right>
        <van-button @click="handle2Del(item)" square text="删除" type="danger" style="height:100%" />
      </template>
    </van-swipe-cell>
    <div @click="handle2Add" class="que-item add">
      <i class="iconfont icon-add"></i>
    </div>
    <!-- <Back /> -->
  </div>
</template>

<script>
import {getAllExam, examDelete} from '@/api'
export default {
  data() {
    return {
      id: this.$route.params.id,
      list: [],
      simpleItem: null
    }
  },
  created() {
    this.initList()
  },
  methods: {
    async initList() {
      const result = await getAllExam({eventId: this.id})
      this.list = result.data
      this.simpleItem = result.data.find(item => item.type === 2) || {type: 2}
    },
    handle2Add() {
      this.$router.push(`/activeAddQue/${this.id}`)
    },
    handle2Del(item) {
      this.$dialog
        .confirm({
          title: '提示',
          confirmButtonColor: '#4A86F6',
          message: `确认删除${item.name}?`
        })
        .then(async () => {
          const result = await examDelete({paperId: item.eventExamPaperId})
          if (result.code === 0) {
            this.initList()
          }
        })
    },
    handle2Detail(item) {
      if (item.type === 2) {
        if (this.simpleItem.eventExamPaperId) {
          this.$router.push(
            `/activeSimpleDetail/${this.id}?paperId=${this.simpleItem.eventExamPaperId}&status=${this.simpleItem.status}`
          )
        } else {
          this.$router.push(`/activeSimpleAdd/${this.id}?paperId=0`)
        }
      } else {
        this.$router.push(`/activeQueDetail/${this.id}?status=${item.status}&paperId=${item.eventExamPaperId}`)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.active-questions {
  min-height: 100vh;
  background: #f4f6f9;
  padding: 16px;
}
.que-item {
  background: #ffffff;
  border-radius: 8px;
  padding: 30px 32px;
  padding-right: 60px;
  margin-bottom: 24px;
  position: relative;
  .title {
    word-wrap: break-word;
    img {
      margin-right: 2px;
      vertical-align: middle;
    }
    span {
      vertical-align: middle;
    }
  }
  .tip {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 56px;
    height: 24px;
    opacity: 1;
    background: #c0c4cc;
    border-radius: 12px 0px 0px 12px;
    font-size: 14px;
    text-align: center;
    line-height: 24px;
    color: #fff;
  }
  .tip.active {
    background: #fda423;
  }
}
.que-item.add {
  border: 2px dashed #dcdfe6;
  padding: 40px 32px;
  i {
    position: absolute;
    font-size: 30px;
    color: #c0c4cc;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
